// axios
import axios from 'axios'


const baseURL = document.location.origin.replace("8080","8000") + process.env.VUE_APP_AXIOS_BASE_URL //if we're running locally switch the port

export default axios.create({
  baseURL,
  withCredentials: true,
  headers: {
     'Content-Type': 'application/json; charset=UTF-8'
  }
})
